import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import palette from 'theme/palette'

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { Box, Tooltip } from '@mui/material'

import LoadingIconButton from 'components/LoadingIconButton'

import { TRANSLATION_KEYS } from '../constants'
import { tableStyles } from '../styles'

interface TableHeaderProps {
  columns: string[]
  hasNextPage?: boolean
  isLoadingMore?: boolean
  onLoadMore?: () => void
}

export const TableHeader = memo(
  ({
    columns,
    hasNextPage = false,
    isLoadingMore = false,
    onLoadMore,
  }: TableHeaderProps) => {
    const { t } = useTranslation('pondOverview')
    const isMobile = new URLSearchParams(window.location.search).get('isMobile') === 'true'

    return (
      <div style={tableStyles.headerRow}>
        <div
          style={{
            ...tableStyles.headerCell,
            ...tableStyles.stickyCol1,
            zIndex: 15,
            backgroundColor: palette.light.grey[200],
            borderLeft: `1.5px solid ${palette.light.grey[300]}`,
            borderRight: `4px solid ${palette.light.grey[300]}`,
            fontSize: isMobile ? '1.625rem' : undefined,
            fontWeight: isMobile ? 700 : undefined,
          }}
        >
          {t(TRANSLATION_KEYS.HEADER.DATE)}
          {hasNextPage && (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                right: '-18px',
                transform: 'translateY(-50%)',
                zIndex: 1000,
              }}
            >
              <Tooltip title={t(TRANSLATION_KEYS.MESSAGES.LOAD_MORE)}>
                <span>
                  <LoadingIconButton
                    loading={isLoadingMore}
                    onClick={onLoadMore}
                    disabled={isLoadingMore}
                    style={{
                      background: 'white',
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <KeyboardBackspaceIcon />
                  </LoadingIconButton>
                </span>
              </Tooltip>
            </Box>
          )}
        </div>
        {columns.map((col, idx) => (
          <div
            key={idx}
            style={{
              ...tableStyles.headerCell,
              fontSize: isMobile ? '1.625rem' : undefined,
              fontWeight: isMobile ? 700 : undefined,
            }}
          >
            {col}
          </div>
        ))}
      </div>
    )
  }
)

TableHeader.displayName = 'TableHeader'
